import React, { useEffect } from "react";
import "./i18n";
import MainRoutes from "./routes/mainRoutes";
import culturalFavicon from "../src/assets/CulturalHeritage/images/favicon.ico";
import kmcFavicon from "../src/assets/kmc/images/favicon.ico";
import msedclFavicon from "../src/assets/msedcl/images/favicon.ico";
import { useLocation } from "react-router-dom";
import merchantFavicon from "../src/assets/merchantPages/favicon.png";
import mpczFavicon from "../src/assets/mpcz/images/favicon.ico";

const App = () => {
  const location = useLocation();
  const path = location?.pathname || "";

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    const isKMC =
      path.includes("/pay-property-tax/") ||
      path.includes("/pay-property-noc-certificate/") ||
      path.includes("/kmc-pay-property-assessment-extract/") ||
      path.includes("/license-fee-payment/") ||
      path.includes("/water-tax-payment/") ||
      path.includes("/general-demand-service/") ||
      path.includes("/track-grievance-status/") ||
      path.includes("/lodge-grievance/");
    const isMSEDCL = path.includes("/msedcl/");
    const isMerchantPage = path.includes("/txn-status/");
    const isMPCZ = path.includes("/mpcz/");

    if (link) {
      if (isKMC) {
        link.href = kmcFavicon;
      } else if (isMSEDCL) {
        link.href = msedclFavicon;
      } else if (isMerchantPage) {
        link.href = merchantFavicon;
      } else if (isMPCZ) {
        link.href = mpczFavicon;
      } else {
        link.href = culturalFavicon;
      }
    }

    if (isKMC) {
      document.title = "kolhapur municipal corporation";
    } else if (isMSEDCL) {
      document.title = "MSEDCL";
    } else if (isMerchantPage) {
      document.title = "Merchant Page";
    } else if (isMPCZ) {
      document.title = "MPCZ";
    } else {
      document.title = "Cultural Heritage Portal";
    }
  }, [path]);

  return <MainRoutes />;
};

export default App;
